/* Fabric Love shared EDD: cart page and cart drawer.
 * Supplier tag lead-time:3: order Monday/Thursday before 11:00 UK time,
 * stock arrives and is dispatched Tuesday/Friday respectively.
 * Other stock: same weekday before 11:00; otherwise next working day.
 * Bank holidays deliberately excluded, as disclosed in the UI.
 */
(function () {
  'use strict';
  if (window.FLDeliveryEstimateInitialized) return;
  window.FLDeliveryEstimateInitialized = true;

  var SECTION = 'fl-cart-lead-time';
  var refreshTimer = null;
  var requestVersion = 0;
  var lastFetchController = null;

  function londonNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { if (x.type !== 'literal') p[x.type] = Number(x.value); });
    return {
      date: new Date(Date.UTC(p.year, p.month - 1, p.day)),
      hour: p.hour, minute: p.minute
    };
  }

  // UTC calendar dates avoid browser time zones and DST date-shift errors.
  function plusDays(d, n) {
    var x = new Date(d.getTime());
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  }
  function working(d) {
    return d.getUTCDay() !== 0 && d.getUTCDay() !== 6;
  }
  function addWorkingDays(d, n) {
    var result = new Date(d.getTime());
    var added = 0;
    while (added < n) {
      result = plusDays(result, 1);
      if (working(result)) added++;
    }
    return result;
  }
  function regularDispatch(now) {
    if (working(now.date) && now.hour < 11) return now.date;
    return addWorkingDays(now.date, 1);
  }
  function supplierDispatch(now) {
    for (var i = 0; i < 8; i++) {
      var orderDay = plusDays(now.date, i);
      var weekday = orderDay.getUTCDay();
      if ((weekday === 1 || weekday === 4) && (i > 0 || now.hour < 11)) {
        return plusDays(orderDay, 1);
      }
    }
    throw new Error('Could not find supplier ordering day');
  }
  function formatDate(d) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
    }).format(d);
  }

  function targets() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[data-fl-delivery-estimate], [data-fl-drawer-delivery-estimate]'
    ));
  }
  function renderMessage(message) {
    targets().forEach(function (box) {
      var first = box.querySelector('[data-fl-first-class], [data-fl-drawer-first-class]');
      var second = box.querySelector('[data-fl-second-class], [data-fl-drawer-second-class]');
      if (first) first.textContent = message;
      if (second) second.textContent = message;
    });
  }
  function renderDates(supplier) {
    var now = londonNow();
    var dispatch = supplier ? supplierDispatch(now) : regularDispatch(now);
    var first = formatDate(addWorkingDays(dispatch, 1));
    var second = formatDate(addWorkingDays(dispatch, 2)) + ' – ' +
                 formatDate(addWorkingDays(dispatch, 3));
    targets().forEach(function (box) {
      var firstEl = box.querySelector('[data-fl-first-class], [data-fl-drawer-first-class]');
      var secondEl = box.querySelector('[data-fl-second-class], [data-fl-drawer-second-class]');
      if (firstEl) firstEl.textContent = first;
      if (secondEl) secondEl.textContent = second;
    });
  }

  function refresh() {
    if (!targets().length) return;
    var version = ++requestVersion;
    if (lastFetchController) lastFetchController.abort();
    lastFetchController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    // Request fresh Liquid, not cached Liquid from initial page load.
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + (root.indexOf('?') === -1 ? '?' : '&') +
      'sections=' + encodeURIComponent(SECTION) + '&_=' + Date.now();
    fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      signal: lastFetchController ? lastFetchController.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Section request failed');
      return response.json();
    }).then(function (data) {
      if (version !== requestVersion) return;
      if (!data || typeof data[SECTION] !== 'string') throw new Error('Section missing');
      var doc = new DOMParser().parseFromString(data[SECTION], 'text/html');
      var flag = doc.querySelector('[data-fl-cart-lead-time-3]');
      if (!flag) throw new Error('Lead-time data missing');
      var value = flag.getAttribute('data-fl-cart-lead-time-3');
      if (value !== 'true' && value !== 'false') throw new Error('Invalid lead-time data');
      renderDates(value === 'true');
    }).catch(function (error) {
      if (version !== requestVersion || error.name === 'AbortError') return;
      console.warn('[Fabric Love EDD]', error);
      renderMessage('Estimate temporarily unavailable');
    });
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 120);
  }
  function observeCartItems() {
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.type === 'childList'; })) {
        scheduleRefresh();
      }
    });
    document.querySelectorAll('[data-products]').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
  }

  function start() {
    refresh();
    observeCartItems();
    ['cart:updated', 'ajaxProduct:added', 'cart:build', 'cart:refresh'].forEach(function (event) {
      document.addEventListener(event, scheduleRefresh);
    });
    window.addEventListener('pageshow', scheduleRefresh);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleRefresh();
    });
    // If Expanse replaces the drawer DOM, refresh the newly inserted estimate.
    var bodyObserver = new MutationObserver(function (records) {
      var newEstimate = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 &&
            ((node.matches && node.matches('[data-fl-drawer-delivery-estimate]')) ||
             (node.querySelector && node.querySelector('[data-fl-drawer-delivery-estimate]')));
        });
      });
      if (newEstimate) scheduleRefresh();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
